import { DatasetInfo } from "api/model/dataset/DatasetInfo";
import React, { useEffect } from "react";
import Bar from "./icons/Bar";
import BoxPlot from "./icons/BoxPlot";
import Histogram from "./icons/Histogram";
import Pie from "./icons/Pie";
import Scatter from "./icons/Scatter";
import Stats from "./icons/Stats";
import LineChart from "./icons/LineChart";
import MultiScatter from "./icons/MultiScatter";

import "./styles/style.scss";

import { ChartType, ChartTypes } from "./models/types";

import Table from "./icons/Table";
import IconButton from "./IconButton";
import DatasetsMenu from "./datasets-menu/DatasetsMenu";

const iconSize = 30;

const ChartIcons: Record<ChartType, any> = {
  BAR: <Bar width={iconSize} height={iconSize} />,
  BOX: <BoxPlot width={iconSize} height={iconSize} />,
  PIE: <Pie width={iconSize} height={iconSize} />,
  RAW: <Table width={iconSize} height={iconSize} />,
  HISTOGRAM: <Histogram width={iconSize} height={iconSize} />,
  SCATTER: <Scatter width={iconSize} height={iconSize} />,
  STATS: <Stats width={iconSize} height={iconSize} />,
  MULTISCATTER: <MultiScatter width={iconSize} height={iconSize} />,
  LINE: <LineChart width={iconSize} height={iconSize} />,
  BASIC: "Basic?",
};

type ChartTypeProps = {
  selectedChartType: ChartType;
  setSelectedCharType: (type: ChartType) => void;
  selectedDatasets: Array<DatasetInfo>;
  setSelectedDatasets: (arr: Array<DatasetInfo>) => void;
};

const ChartTypeMenu = ({
  selectedChartType,
  setSelectedCharType,
  selectedDatasets,
  setSelectedDatasets,
}: ChartTypeProps) => {
  const passiveIconClass = "chartIcons";
  const activeIconClass = "selectedChartIcon";

  useEffect(() => {
    const obj = document.getElementById(`${selectedChartType}-chart`);
    obj?.classList.add(activeIconClass);
    obj?.classList.remove(passiveIconClass);
  }, [selectedChartType]);

  const onClick = (chart: ChartType) => {
    if (chart !== selectedChartType) {
      const obj = document.getElementById(`${selectedChartType}-chart`);
      obj?.classList.remove(activeIconClass);
      obj?.classList.add(passiveIconClass);

      setSelectedCharType(chart);
    }
  };

  return (
    <div className="dynamicCol">
      <div id="dataset-menu" className="mb-5">
        <DatasetsMenu selectedDatasets={selectedDatasets} setSelectedDatasets={setSelectedDatasets} />
      </div>
      {Object.entries(ChartTypes).map(([key, val], index) => {
        return (
          <IconButton
            key={key}
            onClick={() => onClick(key as ChartType)}
            id={key as ChartType}
            className={passiveIconClass}
            tooltip={val}
          >
            {ChartIcons[key as ChartType]}
          </IconButton>
        );
      })}
    </div>
  );
};

export default ChartTypeMenu;
